import { cn } from '@/lib/utils';

import { AdditionalSVGProps } from '@/models/Svg';

export const ShareIcon = (
  props: React.SVGAttributes<SVGElement> & AdditionalSVGProps,
) => {
  const { className, fill = '#010f1d', ...rest } = props;

  return (
    <>
      <svg
        width='26'
        height='29'
        viewBox='0 0 26 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={cn(`fill-[${fill}]`, className)}
        {...rest}
      >
        <path d='M21.6667 29C20.463 29 19.4398 28.5771 18.5972 27.7313C17.7546 26.8854 17.3333 25.8583 17.3333 24.65C17.3333 24.4808 17.3454 24.3054 17.3694 24.1236C17.3935 23.9419 17.4296 23.779 17.4778 23.635L7.29444 17.69C6.88519 18.0525 6.42778 18.3367 5.92222 18.5426C5.41667 18.7485 4.88704 18.851 4.33333 18.85C3.12963 18.85 2.10648 18.4271 1.26389 17.5813C0.421296 16.7354 0 15.7083 0 14.5C0 13.2917 0.421296 12.2646 1.26389 11.4188C2.10648 10.5729 3.12963 10.15 4.33333 10.15C4.88704 10.15 5.41667 10.253 5.92222 10.4589C6.42778 10.6648 6.88519 10.9485 7.29444 11.31L17.4778 5.365C17.4296 5.22 17.3935 5.05712 17.3694 4.87635C17.3454 4.69558 17.3333 4.52013 17.3333 4.35C17.3333 3.14167 17.7546 2.11458 18.5972 1.26875C19.4398 0.422917 20.463 0 21.6667 0C22.8704 0 23.8935 0.422917 24.7361 1.26875C25.5787 2.11458 26 3.14167 26 4.35C26 5.55833 25.5787 6.58542 24.7361 7.43125C23.8935 8.27708 22.8704 8.7 21.6667 8.7C21.113 8.7 20.5833 8.59753 20.0778 8.3926C19.5722 8.18767 19.1148 7.90347 18.7056 7.54L8.52222 13.485C8.57037 13.63 8.60648 13.7934 8.63056 13.9751C8.65463 14.1568 8.66667 14.3318 8.66667 14.5C8.66667 14.6692 8.65463 14.8446 8.63056 15.0264C8.60648 15.2081 8.57037 15.371 8.52222 15.515L18.7056 21.46C19.1148 21.0975 19.5722 20.8138 20.0778 20.6088C20.5833 20.4039 21.113 20.301 21.6667 20.3C22.8704 20.3 23.8935 20.7229 24.7361 21.5688C25.5787 22.4146 26 23.4417 26 24.65C26 25.8583 25.5787 26.8854 24.7361 27.7313C23.8935 28.5771 22.8704 29 21.6667 29Z' />
      </svg>
    </>
  );
};
